import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import PropTypes from 'prop-types';
import React from 'react';

dayjs.extend(utc);

const getDateTemplate = ({ locale, withTime, disableSeconds }) => {
  const normalizedLocale = locale?.toLowerCase();
  const isEnGb = normalizedLocale === 'en-gb';

  if (!withTime) {
    return isEnGb ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
  }

  if (isEnGb) {
    return disableSeconds ? 'DD/MM/YYYY, HH:mm' : 'DD/MM/YYYY, HH:mm:ss';
  }

  return disableSeconds ? 'MM/DD/YYYY, h:mm A' : 'MM/DD/YYYY, h:mm:ss A';
};

const formatDate = (dateValue, { locale, withTime, disableSeconds }) => {
  const dateObject = withTime ? dayjs(dateValue) : dayjs.utc(dateValue);

  if (!dateObject.isValid()) {
    return 'N/A';
  }

  return dateObject.format(getDateTemplate({ locale, withTime, disableSeconds }));
};

const IntlDate = ({ date, locale, withTime, disableSeconds, ...otherProps }) => {
  const dateObject = dayjs(date);
  if (!dateObject.isValid()) {
    return <>N/A</>;
  }

  const formatted = formatDate(date, { locale, withTime, disableSeconds });

  return (
    <time {...otherProps} dateTime={dateObject.toISOString()} data-testid='date-time'>
      {formatted}
    </time>
  );
};

IntlDate.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  locale: PropTypes.string,
  withTime: PropTypes.bool,
  disableSeconds: PropTypes.bool,
};

IntlDate.defaultProps = {
  locale: 'default',
  withTime: false,
  disableSeconds: false,
};

export default IntlDate;
